var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { Link } from '@sitecore-jss/sitecore-jss-react';
export const UnstyledLink = styled((_a) => {
    var { ariaLabel } = _a, others = __rest(_a, ["ariaLabel"]);
    const newProps = ariaLabel ? Object.assign(Object.assign({}, others), { 'aria-label': ariaLabel }) : Object.assign({}, others);
    return React.createElement(Link, Object.assign({}, newProps));
}) `
  text-decoration: none;
`;
